import SearchIcon from '@mui/icons-material/Search';
import type { SxProps } from '@mui/material';
import { styled } from '@mui/material';
import _ from 'lodash';
import type { ReactElement } from 'react';
import { useEffect, useRef } from 'react';
import { makeTransitions, SHADOW } from 'styles/theme';

type Props = {
    sx?: SxProps;
    placeholder?: string;
    handleChange: (arg1: string) => void;
    autoFocus?: boolean;
    testid?: string;
    width?: string;
};

const StySearchBar = styled('div', {
    name: 'StySearchBar',
})(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexFlow: 'row nowrap',
    borderRadius: '1.25rem',
    height: '2.5rem',
    backgroundColor: theme.palette.lightGrey,

    transition: makeTransitions(['box-shadow']),
    '&:hover': { boxShadow: SHADOW },
}));

const StyInput = styled('input', {
    name: 'StyInput',
    shouldForwardProp: (prop) => prop !== 'width',
})<{ width: Props['width'] }>(({ theme, width = '12rem' }) => ({
    border: '0',
    borderRadius: '36px',
    color: theme.palette.black,
    backgroundColor: theme.palette.lightGrey,
    fontSize: '14px',
    fontWeight: '400',
    outline: 'none',
    width,
}));

const applySearch = (search: string, callback: (arg1: string) => void) => {
    callback(search);
};

const debouncedSearch = _.debounce(applySearch, 500);

/** @deprecated Use design-system SearchBar instead */
const DeprecatedSearchBar = (props: Props): ReactElement => {
    const { placeholder = '', sx } = props;
    const inputRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        if (props.autoFocus && inputRef && inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    return (
        <StySearchBar sx={sx}>
            <SearchIcon sx={{ color: 'black', ml: '1rem' }} />
            <StyInput
                ref={inputRef}
                type="text"
                placeholder={placeholder}
                onChange={(event) =>
                    debouncedSearch(event.target.value, props.handleChange)
                }
                data-testid={props.testid}
                width={props.width}
            />
        </StySearchBar>
    );
};
export default DeprecatedSearchBar;
